export const SET_INTERVAL_MINUTES_FOR_UPDATE ="SET_INTERVAL_MINUTES_FOR_UPDATE";
export const GET_DATA_DASHBOARD = "GET_DATA_DASHBOARD";
export const GET_DATA_DASHBOARD_EXITO = "GET_DATA_DASHBOARD_EXITO";
export const GET_DATA_DASHBOARD_ERROR = "GET_DATA_DASHBOARD_ERROR";